import { VerificationStatus } from '../enums/VerificationStatus';
import { UploadItem } from './UploadItem';

export class Verification {
  public condition? = true;
  public continuousUploads? = false;
  public copy: string;
  public headline: string;
  public isOptional? = false;
  public name: string;
  public path: string;
  public uploadItems: UploadItem[];

  public constructor(verification?: Verification | Partial<Verification>) {
    Object.assign(this, verification);
  }

  public get isComplete(): boolean {
    return (
      !this.continuousUploads &&
      this.uploadItems.every((item): boolean => item.isUploaded)
    );
  }

  public get status(): VerificationStatus {
    if (this.isComplete) {
      return VerificationStatus.COMPLETE;
    }

    if (this.isOptional) {
      return VerificationStatus.OPTIONAL;
    }

    return VerificationStatus.REQUESTED;
  }
}
